import React, { useState, useRef, useEffect } from 'react';
import Datepicker from "react-tailwindcss-datepicker";
import moment from 'moment';

const DateRangePicker = (props) => {
  const {
    startDate,
    endDate,
    basePath = '/dashboard/reports',
    startFieldName = 'charge_time_start',
    endFieldName = 'charge_time_end',
  } = props;

  const formInputRef = useRef(null);
  const [startDateVal, setStartDateVal] = useState(startDate ? moment.unix(Number(startDate)).format("YYYY-MM-DD") : null);
  const [endDateVal, setEndDateVal] = useState(endDate ? moment.unix(Number(endDate)).format("YYYY-MM-DD") : null);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  // Submit form after state updates and DOM re-renders with new values
  useEffect(() => {
    if (shouldSubmit) {
      formInputRef.current?.form?.requestSubmit();
      setShouldSubmit(false);
    }
  }, [shouldSubmit]);

  const handleDatesChanged = ({ startDate, endDate }) => {
    if (!!startDate && !!endDate) {
      setStartDateVal(moment(startDate).utc(true).startOf('day').format("YYYY-MM-DD"));
      setEndDateVal(moment(endDate).utc(true).endOf('day').format("YYYY-MM-DD"));
      setShouldSubmit(true);
    } else {
      setStartDateVal(null);
      setEndDateVal(null);
      setShouldSubmit(true);
    }
  };

  const setUnixStart = (date) => {
    if (!date) return null
    return moment(date).utc(true).startOf('day').format('X')
  }
  const setUnixEnd = (date) => {
    if (!date) return null
    return moment(date).utc(true).endOf('day').format('X')
  }

  // ?charge_time_end=1676159999&charge_time_start=1675814400&search_value=asdfsdf
  return (
    <div>
      <input
        type="hidden"
        ref={formInputRef}
        id={startFieldName}
        name={startFieldName}
        value={setUnixStart(startDateVal) || ''}
      />
      <input
        type="hidden"
        id={endFieldName}
        name={endFieldName}
        value={setUnixEnd(endDateVal) || ''}
      />
      <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
      <Datepicker
        primaryColor="indigo"
        value={{ startDate: startDateVal, endDate: endDateVal }}
        onChange={handleDatesChanged}
        placeholder="Select date range"
        showShortcuts={true}
        useRange={true}
      />
    </div>
  );
};

export default DateRangePicker;
